// src/components/CMYKVert.jsx
import React from "react";

const CMYKVertLarge = ({ width = 20, height = 575, gap = 35 }) => {
  const colors = ["#000000", "#FFFF00", "#FF00FF", "#00FFFF"]; // Black, Yellow, Magenta, Cyan
  const rectsPerColor = 4; // Number of rectangles per color
  const totalColorHeight = (height - gap * (colors.length - 1)) / colors.length; // Height allocated per color group
  const rectHeight = totalColorHeight / rectsPerColor; // Height of each rectangle within a color group

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {colors.map((color, colorIndex) =>
        Array.from({ length: rectsPerColor }).map((_, i) => {
          const opacity = 1 - i * 0.25; // Gradation from 1.0 to 0.25
          const yPosition =
            colorIndex * (totalColorHeight + gap) + i * rectHeight; // Adjust position for gaps between colors

          return (
            <rect
              key={`${color}-${i}`}
              x="0"
              y={yPosition}
              width={width}
              height={rectHeight}
              fill={color}
              opacity={opacity}
            />
          );
        })
      )}
    </svg>
  );
};

export default CMYKVertLarge;
